import { render, staticRenderFns } from "./RuleModuleFull.vue?vue&type=template&id=4a9aae51"
import script from "./RuleModuleFull.vue?vue&type=script&lang=js"
export * from "./RuleModuleFull.vue?vue&type=script&lang=js"
import style0 from "./RuleModuleFull.vue?vue&type=style&index=0&id=4a9aae51&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports